import React from "react";
import Plot from "react-plotly.js";
import ReactGA from "react-ga";
import { inject, observer } from "mobx-react";
import Autobind from "autobind-decorator";
import HUGuideTableManager from "component/molecules/HUGuideTable/HUGuideTableManager";
import MeassurementTable from "component/molecules/measurementTable";
import SVGIcons from "assets/icon";
import PropTypes from "prop-types";
import classNames from "classnames";
import Mixins from "../../../core/mixins/index";

import TestHistData from "../../../data.json";
import { RGBADepthPacking } from "three/src/constants";

// const MeasurementDataset = [
//   {
//     color: "#751a15",
//     name: "SFat",
//     area: "",
//   },
//   {
//     color: "#452781",
//     name: "VFat",
//     area: "",
//   },
//   {
//     color: "#e3df02",
//     name: "IMAT",
//     area: "",
//   },
//   {
//     color: "#00d1d4",
//     name: "LAMA",
//     area: "",
//   },
//   {
//     color: "#a80a02",
//     name: "NAMA",
//     area: "",
//   },
//   {
//     //  color:"#695b87",
//     color:["#00d1d4", "#a80a02"],
//     name:"SMA",
//     area:""
//   }
// ];

@inject("sarcopeniaMeasureStore")
@Autobind
@observer
class MeasurementPanel extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    disabled: false,
  };

  samplingUnit = 5;

  componentDidMount() {
    this.guideInfoRef.addEventListener("mouseenter", (event) => {
      // Send user event to Google Analytics
      ReactGA.event({
        category: "Measurement",
        action: "show dialog about HU range guidance as region",
      });
      // Float HU range guidance dialog as region
      HUGuideTableManager.floating();
    });
    this.guideInfoRef.addEventListener("mouseleave", (event) => {
      // Send user event to Google Analytics
      ReactGA.event({
        category: "Measurement",
        action: "hide dialog about HU range guidance as region",
      });
      // Hide HU range guidance dialog as region
      HUGuideTableManager.hiding();
    });
  }
  render() {
    const { disabled } = this.props;
    const { sarcopeniaMeasureStore } = this.props;
    const measuredHistograms = sarcopeniaMeasureStore.getHistograms();
    let MeasurementDataset;
    if (sarcopeniaMeasureStore.mode ==='view')
    {
      // VIEW모드일 때, 테이블 색상
      MeasurementDataset = [
        {
          color: "#371822",
          name: "SFat",
          area: "",
        },
        {
          color: "#452781",
          name: "VFat",
          area: "",
        },
        {
          color: "#e3df02",
          name: "IMAT",
          area: "",
        },
        {
          color: "#00d1d4",
          name: "LAMA",
          area: "",
        },
        {
          color: "#a80a02",
          name: "NAMA",
          area: "",
        },
        {
          //  color:"#695b87",
          color:["#00d1d4", "#a80a02"],
          name:"SMA",
          area:""
        }
      ];
    }
    else
    {
      // EDIT모드일 때, 테이블 색상
      MeasurementDataset = [
        {
          color: "#371822",
          name: "SFAT",
          area: "",
        },
        {
          color: "#00d1d4",
          name: "SMA",
          area: "",
        },
        {
          color: "#e3df02",
          name: "VFAT",
          area: "",
        }
      ];
    }
    return (
      <div className="control-item">
        <label className="item-title" style={{ marginBottom: "0.0em" }}>
          {"Measurement"}
          <span
            ref={(guideInfoRef) => {
              this.guideInfoRef = guideInfoRef;
            }}
            className="item-title-sub"
            style={{ marginLeft: "10px" }}
          >
            <SVGIcons.SVGSmallInfoIcon style={{ marginLeft: "10px" }} />
          </span>
        </label>
        <span className="item-title-sub pull-right">
          <label
            className="item-title-sub__text item-title--bolder"
            style={{ width: "50px", textAlign: "right", marginBottom: "0.0em" }}
          >
            (HU)
          </label>
        </span>
        <div className={classNames("item-content", "item-panel--no-bg")}>
          <Plot
            data={[
              // SFat
              {
                name: "SFat",
                x:
                  measuredHistograms["SFat"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["SFat"]["x"],
                    this.samplingUnit
                  ),
                y:
                  measuredHistograms["SFat"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["SFat"]["y"],
                    this.samplingUnit
                  ),
                type: "scatter",
                mode: "lines",
                showlegent: false,
                fill: "tozeroy",
                line: {
                  color: "#6e1d14",
                  width: 2,
                  dash: "solid",
                  shape: "linear",
                  simplify: true,
                },
                fillcolor: "#371822",
                error_y: {
                  visible: false,
                },
                error_x: {
                  visible: false,
                },
              },
              // VFat
              {
                name: "VFat",
                x:
                  measuredHistograms["VFat"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["VFat"]["x"],
                    this.samplingUnit
                  ),
                y:
                  measuredHistograms["VFat"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["VFat"]["y"],
                    this.samplingUnit
                  ),
                type: "scatter",
                mode: "lines",
                showlegent: false,
                fill: "tozeroy",
                line: {
                  color: "#42267c",
                  width: 2,
                  dash: "solid",
                  shape: "linear",
                  simplify: true,
                },
                fillcolor: "#261b4c",
                error_y: {
                  visible: false,
                },
                error_x: {
                  visible: false,
                },
              },
              // LAMA
              {
                name: "LAMA",
                x:
                  measuredHistograms["LAMA"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["LAMA"]["x"],
                    this.samplingUnit
                  ),
                y:
                  measuredHistograms["LAMA"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["LAMA"]["y"],
                    this.samplingUnit
                  ),
                type: "scatter",
                mode: "lines",
                showlegent: false,
                fill: "tozeroy",
                line: {
                  color: "#02d4d8",
                  width: 2,
                  dash: "solid",
                  shape: "linear",
                  simplify: true,
                },
                fillcolor: "#0c6070",
                error_y: {
                  visible: false,
                },
                error_x: {
                  visible: false,
                },
              },
              // IMA
              {
                name: "IMAT",
                x:
                  measuredHistograms["IMA"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["IMA"]["x"],
                    this.samplingUnit
                  ),
                y:
                  measuredHistograms["IMA"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["IMA"]["y"],
                    this.samplingUnit
                  ),
                type: "scatter",
                mode: "lines",
                showlegent: false,
                fill: "tozeroy",
                line: {
                  color: "#cae100",
                  width: 2,
                  dash: "solid",
                  shape: "linear",
                  simplify: true,
                },
                fillcolor: "#796b20",
                error_y: {
                  visible: false,
                },
                error_x: {
                  visible: false,
                },
              },
              // NAMA
              {
                name: "NAMA",
                x:
                  measuredHistograms["NAMA"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["NAMA"]["x"],
                    this.samplingUnit
                  ),
                y:
                  measuredHistograms["NAMA"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["NAMA"]["y"],
                    this.samplingUnit
                  ),
                type: "scatter",
                mode: "lines",
                showlegent: false,
                fill: "tozeroy",
                line: {
                  color: "#c00000",
                  width: 2,
                  dash: "solid",
                  shape: "linear",
                  simplify: true,
                },
                fillcolor: "#550c1c",
                error_y: {
                  visible: false,
                },
                error_x: {
                  visible: false,
                },
              },
              // Muscle
              {
                name: "Muscle",
                x:
                  measuredHistograms["Muscle"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["Muscle"]["x"],
                    this.samplingUnit
                  ),
                y:
                  measuredHistograms["Muscle"] &&
                  Mixins.extractSampling1dArray(
                    measuredHistograms["Muscle"]["y"],
                    this.samplingUnit
                  ),
                type: "scatter",
                mode: "lines",
                showlegent: false,
                fill: "tozeroy",
                line: {
                  color: "#695b87",
                  width: 2,
                  dash: "solid",
                  shape: "linear",
                  simplify: true,
                },
                fillcolor: "#3c344c",
                error_y: {
                  visible: false,
                },
                error_x: {
                  visible: false,
                },
              },
            ]}
            layout={{
              margin: {
                t: 0,
                b: 20,
                l: 0,
                r: 0,
                pad: 0,
                autoexpand: true,
              },

              width: 255,
              height: 75,
              xaxis: {
                anchor: "x",
                type: "linear",
                range: [-220, 180], // sets the range of xaxis
                ticklen: 0,
                tickwidth: 0,
                tickvals: [-190, -30, 30, 150],
                ticktext: ["-190", "-30", "30", "150"],
                autorange: false,
                showgrid: false,
                showline: false,
                linewidth: 3,
                showticklabels: true,
                zerolinewidth: 0,
                zeroline: false,
                showspikes: false,
                tickfont: {
                  size: 12,
                  color: "rgb(115, 119, 144)",
                  family: '"Open Sans", verdana, arial, sans-serif, bolder',
                },
              },
              yaxis: {
                y: "y",
                type: "linear",

                autorange: true,
                gridwidth: 0,
                showgrid: false,
                showline: false,
                linewidth: 3,
                showticklabels: false,
                zerolinewidth: 2,
                zeroline: true,
                zerolinecolor: "#7f7f7f",
                showspikes: false,
                visible: true,
              },
              plot_bgcolor: "#12142b",
              paper_bgcolor: "#12142b",
              // 범례 설정
              showlegend: false,
            }}
            config={{
              displayModeBar: false,
            }}
          />
        </div>
        {/* FIXME */}
        <label className="item-title" style={{ height: "24px" }}>
          <span className="item-title-sub pull-right">
            <label
              className="item-title-sub__text item-title--bolder"
              style={{ width: "50px", textAlign: "right" }}
            >
              (cm<sup>2</sup>){/* (㎠) */}
            </label>
          </span>
        </label>
        <div className={classNames("item-content", "item-panel")}>
          <MeassurementTable disabled={disabled} dataset={MeasurementDataset} />
        </div>
      </div>
    );
  }
}

export default MeasurementPanel;
